<template>
  <div>
    <span class="breadcrumb">
      <span v-for="path in ($route.name.split('-'))">
        {{ path.charAt(0).toUpperCase() + path.substring(1) }}
        <i class="icon icon-icon_arrow-right"></i>
      </span>
    </span>
    <h1>{{$route.meta.action}}</h1>
  </div>
</template>

<script>
export default {
  name: `BreadCrumb`,
}
</script>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue